import Typography from "antd/es/typography/Typography";
import React from "react";
import Chart from "react-apexcharts";

const PieExpert = ({ expertiseDist }) => {
  const { Title } = Typography;

  const options = [
    { value: "webDevelopment", label: "Web Development" },
    { value: "mobileDevelopment", label: "Mobile Development" },
    { value: "digitalMarketing", label: "Branding & Digital Marketing" },
    { value: "uiUxDesign", label: "UI & UX Design" },
    { value: "itConsulting", label: "IT Consulting" },
  ];

  // Extract values and labels for the pie chart
  const chartSeries = Object.values(expertiseDist);
  const chartLabels = Object.keys(expertiseDist).map((key) => {
    const option = options.find((opt) => opt.value === key);
    return option ? option.label : key;
  });

  const digitalShiftsColors = [
    "#4FB590",
    "#67BFA6",
    "#7FCABD",
    "#80C0AC",
    "#77B6A3",
  ];

  const chartOptions = {
    series: chartSeries,
    chart: {
      width: "100%",
      type: "pie",
      toolbar: {
        show: false,
      },
    },
    labels: chartLabels,
    theme: {
      monochrome: {
        enabled: false,
      },
    },
    colors: digitalShiftsColors,
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -5,
        },
      },
    },
    dataLabels: {
      formatter(val, opts) {
        const name = opts.w.globals.labels[opts.seriesIndex];
        return [name, val.toFixed(1) + "%"];
      },
    },
    legend: {
      show: true,
      position: "bottom",
      fontSize: "12px",
      labels: {
        colors: "#62776f",
      },
    },
  };

  if (!chartSeries.length) {
    return <div className="dashboard-empty-state">No expertise data yet.</div>;
  }

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Distribution</span>
          <Title level={5}>Expertise Distribution</Title>
          <span className="dashboard-panel__subtext">
            See which disciplines currently dominate the expert pipeline.
          </span>
        </div>
        <span className="dashboard-panel__metric">{chartSeries.length}</span>
      </div>
      <div className="dashboard-panel__chart dashboard-panel__chart--compact">
        <Chart options={chartOptions} series={chartOptions.series} type="pie" />
      </div>
    </div>
  );
};

export default PieExpert;
